import React from 'react';
import { Card } from 'components';
import { Col, Row, Typography } from 'antd';
import styles from './styles.module.scss';

interface IAnalyticsCard {
  width?: string;
  icon?: React.ReactNode;
  title?: string | React.ReactNode;
  analyticData: string | number;
  analyticText: string;
}

export const AnalyticsCard = React.memo<IAnalyticsCard>((props) => {
  const { width, icon, title, analyticData, analyticText } = props;
  return (
    <Card className={styles.analytics_card} style={{ width: width || '100%' }}>
      <Row gutter={[16, 16]}>
        <Col>{icon}</Col>
        <Col className={styles.title}>{title}</Col>
        <Col span={24}>
          <Row>
            <Typography className={styles.data}>{analyticData}</Typography>
            <Typography className={styles.text}>{analyticText}</Typography>
          </Row>
        </Col>
      </Row>
    </Card>
  );
});
